export const CopyToEtsDestinationId = 'f2ce0f82-dca8-4fa0-92e1-5d222ea9b884';
export const CopyToTOSWebDestinationId = '328aeb06-6de1-4dc7-8063-e58868e65c94';
export const CopyToTOSDesktopDestinationId = 'f57cc704-0295-4472-9571-b809adfbccce';


export abstract class AccessControlService {
  abstract init(): Promise<void>;
  abstract isSecureElementAvailable(id: string): boolean;
}
